import React, { useEffect } from "react";
import { Callout, Icon, Tag, RadioGroup, Radio, Popover } from "@blueprintjs/core";

import { Trans } from "react-i18next";

import { authenticatedGetFetch } from "../../../utils/AuthenticatedFetch";

export function ALPRServer(props) {
  const [parkLookup, setParkLookup] = React.useState({});

  useEffect(() => {
    authenticatedGetFetch('/parks',
      (response) => {
        const lookup = {};
        for (const park of response)
          lookup[park.id] = <span>{park.id} - {park.name}</span>
        setParkLookup(lookup);
      })
  }, []);

  return <Callout title={props.ip} icon={props.status ? "tick-circle" : "offline"} intent={props.status ? "primary" : "danger"}>
    {!props.status && <div><Icon icon="offline" /> <Trans>disconnected</Trans></div>}
    <div><Trans>managed parks:</Trans>{props.parks.map((park, index) => (<Tag key={park}>{parkLookup[park] || <span><Trans>park</Trans> {park}</span>}</Tag>))}</div>


    <RadioGroup
      label={<Trans>coupling mode:</Trans>}
      onChange={(selection) => props.onClouplingModeChange(selection.target.value)}
      selectedValue={props.couplingMode}
      disabled={![2, 3].includes(props.couplingMode)}
      inline={true}
    >
      <Radio label={<span>
        <Trans>couplingmode2</Trans>{" "}
        <Popover
          interactionKind="hover"
          content={<div style={{ maxWidth: "25ch" }}><Trans>couplingmode2_helper</Trans></div>}
        ><Icon icon="help" />
        </Popover></span>}
        value={2} />

      <Radio label={<span>
        <Trans>couplingmode3</Trans>{" "}
        <Popover
          interactionKind="hover"
          content={<div style={{ maxWidth: "25ch" }}><Trans>couplingmode3_helper</Trans></div>}
        ><Icon icon="help" />
        </Popover></span>} value={3} />
    </RadioGroup>

  </Callout>
}